const routes = [
  {
    path: 'alerts',
    component: () => import(/* webpackChunkName: "alerts" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'alerts',
        component: () => import(/* webpackChunkName: "alerts" */ './views/Alerts.vue'),
      },
    ],
  },
];

export default routes;
